import React, { useState, useEffect, useContext } from "react";
import { Collapse, List, Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { Formik } from "formik";
import { AuthContext } from "../shared/auth-context";
import { useNavigate } from "react-router-dom";
import "./PropertyType.css";
const { Panel } = Collapse;
function Details() {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const [detailsModal, setDetailsModal] = useState(false);
  const [subDetailsModal, setSubDetailsModal] = useState(false);
  const [detailType, setDetailType] = useState("");
  const [alldetails, setAllDetails] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/property/alldetails`
    );
    setAllDetails(data);
  };

  console.log(alldetails);

  if (alldetails.length === 0) {
    return (
      <div
        id="spinner"
        style={{ backdropFilter: "blur(4px)" }}
        class="show position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
      >
        <div
          class="spinner-border text-primary"
          style={{ width: "3rem", height: "3rem" }}
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  const handledetailsModalOpen = () => {
    setDetailsModal(true);
  };

  const handledetailsModalClose = () => {
    setDetailsModal(false);
  };
  const handlesubDetailsModalOpen = () => {
    setSubDetailsModal(true);
  };

  const handlesubDetailsModalClose = () => {
    setSubDetailsModal(false);
  };

  const handleDeleteDetailType = (detailtype) => {
    Modal.confirm({
      title: "Confirmation",
      content: "Are you sure you want to delete this Property Type?",
      okText: "Yes",
      cancelText: "No", // Updated from 'okCancel' to 'cancelText'
      okButtonProps: { // Add this to style the OK button
        style: { width: "80px" },
      },
      cancelButtonProps: {
        style: { width: "80px" },
      },
      onOk: () => {
        axios
          .delete(`${process.env.REACT_APP_BASE_URL}/property/detailtype/`, {
            data: { detailtype }, // Send the 'detailtype' as part of the request body
          })
          .then((res) => {
            if (res.status === 200) {
              // Check the response status code appropriately
              Modal.success({
                title: "Success",
                content: "Detail Deleted successfully.",
              });
              fetchData();
            }
          })
          .catch((error) => {
            alert("error ", error);
          });
      },
      onCancel: () => {
        // Handle cancel logic if needed
      },
    });
  };

  const handleDeleteDetailSubType = (detailtype, detailsubtype) => {
    Modal.confirm({
      title: "Confirmation",
      content: "Are you sure you want to delete this Property SubType?",
      okText: "Yes",
      cancelText: "No", // Updated from 'okCancel' to 'cancelText'
      okButtonProps: { // Add this to style the OK button
        style: { width: "80px" },
      },
      cancelButtonProps: {
        style: { width: "80px" },
      },
      onOk: () => {
        axios
          .delete(`${process.env.REACT_APP_BASE_URL}/property/detailsubtype`, {
            data: { detailtype, detailsubtype }, // Send the 'detailtype' as part of the request body
          })
          .then((res) => {
            if (res.status === 200) {
              // Check the response status code appropriately
              Modal.success({
                title: "Success",
                content: "Sub Detail Deleted successfully.",
              });
              fetchData();
            }
          })
          .catch((error) => {
            alert("error ", error);
          });
      },
      onCancel: () => {
        // Handle cancel logic if needed
      },
    });
  };

  return (
    <div>
      {/* <h1>
                Property Type
            </h1> */}
      <div>
        <Collapse
          size="large"
          // onChange={onChange}
          width={700}
          style={{
            marginTop: "100px",
            padding: "50px",
          }}
        >
          {alldetails.map((type, index) => (
            <Panel
              header={
                <div>
                  <DeleteOutlined
                    onClick={() => handleDeleteDetailType(type.detailtype)}
                    style={{ color: "red", marginRight: 12, fontSize: 24 }}
                  />
                  {type.detailtype}
                </div>
              }
              key={index}
              className="panel"
            >
              <List>
                {type.detailsubtype.map((subtype, index) => (
                  <div>
                    <List.Item>
                      <DeleteOutlined
                        onClick={() =>
                          handleDeleteDetailSubType(type.detailtype, subtype)
                        }
                        style={{ color: "red", marginRight: 12, fontSize: 24 }}
                      />
                      {index + 1}. {subtype}{" "}
                    </List.Item>
                  </div>
                ))}
              </List>
              <div className="subdetaildiv" >
                <button
                className="subdetailbutton"
                  onClick={() => {
                    console.log(type.detailtype);
                    setDetailType(type.detailtype);
                    handlesubDetailsModalOpen();
                  }}
                >
                  Add SubDetail
                </button>
              </div>
            </Panel>
          ))}
          <div style={{ float:'right', marginTop:3 }}>
            <button onClick={handledetailsModalOpen}>Add Detail</button>
          </div>
        </Collapse>
      </div>
      <div style={{ marginTop: "50px" }}>
        <Modal
          title="Update Detail Sub Type"
          visible={subDetailsModal}
          onCancel={handlesubDetailsModalClose}
          footer={null}
        >
          <Formik
            initialValues={{
              detailtype: detailType,
              detailsubtype: [],
            }}
            validate={(values) => {
              const errors = {};
              if (!values.detailsubtype) {
                errors.detailsubtype = "Detail SubType Required";
              }

              return errors;
            }}
            onSubmit={async (values, { setSubmitting }) => {
              console.log(detailType);
              console.log(values);
              try {
                const response = await axios.post(
                  `${process.env.REACT_APP_BASE_URL}/property/updatedetailtype`,
                  {
                    detailType: detailType,
                    detailsubtype: values.detailsubtype,
                  }
                );
                if (response.data.message) {
                  Modal.warning({
                    title: response.data.message,
                  });
                } else {
                  if (response.status === 200) {
                    Modal.success({
                      title: response.data,
                    });
                    setSubDetailsModal(false);
                    fetchData();
                  }
                }
              } catch (err) {
                console.log(err);
              }
              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form
                onSubmit={handleSubmit}
                id="editmodal"
                className="w-full max-w-sm"
              >
                <div
                  className="md:flex md:items-center mb-6"
                  style={{ paddingTop: "40px" }}
                >
                  <div
                    className="col-12"
                    style={{ paddingTop: "20px", paddingBottom: "20px" }}
                  >
                    <div className="form-floating">
                      <input
                        type="text"
                        name="detailsubtype"
                        className="form-control"
                        id="detailsubtype"
                        placeholder="Detail SubType"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.detailsubtype}
                      />

                      <label htmlFor="password">Detail SubType</label>
                    </div>
                  </div>

                  <div
                    className="col-12"
                    style={{ paddingTop: "20px", paddingBottom: "30px" }}
                  >
                    <button
                      className="btn btn-primary w-100 py-3"
                      type="submit"
                      // disabled={isSubmitting}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </Modal>
      </div>
      <div style={{ marginTop: "50px" }}>
        <Modal
          title="New Detail Type"
          visible={detailsModal}
          onCancel={handledetailsModalClose}
          footer={null}
        >
          <Formik
            initialValues={{
              detailtype: "",
            }}
            validate={(values) => {
              const errors = {};
              if (!values.detailtype) {
                errors.detailtype = "Detail Type Required";
              }

              return errors;
            }}
            onSubmit={async (values, { setSubmitting }) => {
              console.log(values);
              try {
                const response = await axios.post(
                  `${process.env.REACT_APP_BASE_URL}/property/adddetailtype`,
                  { detailtype: values.detailtype, detailsubtype: [] }
                );
                if (response.data.message) {
                  Modal.warning({
                    title: response.data.message,
                  });
                } else {
                  if (response.status === 200) {
                    Modal.success({
                      title: response.data,
                    });
                    setDetailsModal(false);
                    fetchData();
                  }
                }
              } catch (err) {
                console.log(err);
              }
              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form
                onSubmit={handleSubmit}
                id="editmodal"
                className="w-full max-w-sm"
              >
                <div
                  className="md:flex md:items-center mb-6"
                  style={{ paddingTop: "40px" }}
                >
                  <div
                    className="col-12"
                    style={{ paddingTop: "20px", paddingBottom: "20px" }}
                  >
                    <div className="form-floating">
                      <input
                        type="text"
                        name="detailtype"
                        className="form-control"
                        id="detailtype"
                        placeholder="Detail Type"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.detailtype}
                      />

                      <label htmlFor="password">Detail Type</label>
                    </div>
                  </div>

                  <div
                    className="col-12"
                    style={{ paddingTop: "20px", paddingBottom: "30px" }}
                  >
                    <button
                      className="btn btn-primary w-100 py-3"
                      type="submit"
                      // disabled={isSubmitting}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </Modal>
      </div>
    </div>
  );
}

export default Details;
